import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';

import { UserService } from '../services';

export const ErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const userService = inject(UserService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((err: any) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
          const returnUrl = router.url.startsWith('/auth') ? '/' : router.url;
          userService.logout();
          router.navigate(['/auth/sign-in'], { queryParams: { returnUrl } });
        }
      }

      return throwError(() => err);
    }),
  );
};
